import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const api = axios.create({ baseURL: `${BACKEND_URL}/api` });

const TOKEN_KEY = "tga_token";
export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => (t ? localStorage.setItem(TOKEN_KEY, t) : localStorage.removeItem(TOKEN_KEY));

api.interceptors.request.use((cfg) => {
  const t = getToken();
  if (t) cfg.headers.Authorization = `Bearer ${t}`;
  return cfg;
});

export const fileUrl = (u) => (!u ? "" : u.startsWith("/api/") ? `${BACKEND_URL}${u}` : u);

export function formatError(e) {
  const detail = e?.response?.data?.detail;
  if (detail == null) return e?.message || "Qualcosa è andato storto. Riprova.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) return detail.map((d) => (d?.type === "string_pattern_mismatch" ? `Il campo "${d.loc?.slice(-1)[0]}" contiene caratteri non validi (usa solo lettere, numeri, - e _)` : String(d?.msg || JSON.stringify(d)).replace(/^Value error, /, ""))).join(" ");
  return detail.msg || String(detail);
}

export const FALLBACK_COVER = "https://images.unsplash.com/photo-1669801158950-f663cf15298c?crop=entropy&cs=srgb&fm=jpg&q=80&w=800";
export const FALLBACK_ARTIST = "https://images.unsplash.com/photo-1574793954837-b7938eb5a662?crop=entropy&cs=srgb&fm=jpg&q=80&w=800";
export const HERO_IMAGE = "https://images.unsplash.com/photo-1557787824-93666b9f6093?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920";
export const ABOUT_IMAGE = "https://images.unsplash.com/photo-1599423424751-54e0c1187a02?crop=entropy&cs=srgb&fm=jpg&q=85&w=1400";
